// Header Scroll
const header = document.querySelector("#masthead");
let prevScroll = window.pageYOffset;

const scrollHeaderAnimation = function() {
    const currentScroll = window.pageYOffset;
    const headerHeight = header.offsetHeight * 3;
    const headerOffset = header.offsetHeight * 6;
    
    if(currentScroll <= headerHeight) {
        header.classList.remove("scroll");
        header.classList.remove("hide");
    }
    else if(currentScroll < headerOffset  && !header.classList.contains("active")) {
        header.classList.add("hide");
    }
    else if (prevScroll < currentScroll && !header.classList.contains("active")) {
        // Hide header on scroll down
        header.classList.add("hide");
        header.classList.add("scroll");
    } else {
        // Show header on scroll up
        header.classList.remove("hide");
        header.classList.add("scroll");
    }

    prevScroll = currentScroll;
}

window.addEventListener("scroll", function() {
    scrollHeaderAnimation();
});

// Mobile Menu
const menuToggle = document.querySelector(".menu-toggle");
const headerMenu = document.querySelector(".header-menu");
const subMenuLinks = document.querySelectorAll(".menu-item-has-children > a");
const backButton = document.querySelector(".menu-toggle_back");
const subMenus = document.querySelectorAll("ul.sub-menu");
let mobileMenuMq = window.matchMedia('(max-width:1080px)');

window.addEventListener('resize', function() {
    if(!mobileMenuMq.matches && menuToggle.classList.contains("active")) {
        toggleMobileMain();
        closeSubMenu();
    }
});

menuToggle.addEventListener("click", function() {
    toggleMobileMain();
});

const toggleMobileMain = function() {
    header.classList.toggle("active");
    if ( menuToggle.getAttribute( 'aria-expanded' ) === 'true' ) {
        menuToggle.setAttribute( 'aria-expanded', 'false' );
    } else {
        menuToggle.setAttribute( 'aria-expanded', 'true' );
    }
}

const openSubMenu = function(e) {
    e.preventDefault()
    const trigger = e.target;
    const subMenu = trigger.nextElementSibling;
    subMenu.classList.add("active");
    backButton.classList.add("active");
}

const closeSubMenu = function() {
    backButton.classList.remove("active");
    subMenus.forEach(menu => {
        menu.classList.remove("active");
    })
}

if(mobileMenuMq.matches && subMenuLinks) {
    subMenuLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            openSubMenu(e);
        })
    })
    backButton.addEventListener("click", function() {
        closeSubMenu();
    })
}

// Search button

const searchCancelBtns = document.querySelectorAll(".search-cancel");
const ivorySearchInput = document.querySelector(".is-search-input");
const resourcesSearchInput = document.querySelector(".search-field_resources");
const searchSubmit = document.querySelector(".search-submit");

function showSearchCancel() {
    searchCancelBtns.forEach(btn => {
        btn.classList.add("active");
    })
}

function hideSearchCancel() {
    searchCancelBtns.forEach(btn => {
        btn.classList.remove("active");
    })
}

if( ivorySearchInput ) {
    ivorySearchInput.addEventListener("input", function(e) {
        let value = ivorySearchInput.value;
        if( value != null && value != "" ) {
            showSearchCancel()
        } else if( value == null || value == "" ) {
            hideSearchCancel()
        }
    });
}

document.addEventListener('input', function(e) {
    let input = e.target;
    if( input && input.classList.contains("search-field_resources" ) ) {
        let value = input.value;
        let parent = input.parentElement;
        let cancelBtn = parent.querySelector(".search-cancel");
        if( value != null && value != "" ) {
            cancelBtn.classList.add("active");
        } else if( value == null || value == "" ) {
            cancelBtn.classList.remove("active");
        }
    }
})

document.addEventListener('click', function(e) {
    let button = e.target;
    if( button && button.classList.contains("search-cancel") ) {
        e.preventDefault();
        if( ivorySearchInput ) {
            ivorySearchInput.value = "";
        } else if( resourcesSearchInput ) {
            resourcesSearchInput.value = "";
        }
        hideSearchCancel()
    }
})